import * as React from "react";

import { themed } from "../../../Internals/ThemeProvider/ThemedWorkaround";
import { HorizontalAlign } from "../../../Layout/SimpleTable/HorizontalAlign";
import { VerticalAlign } from "../../../Layout/SimpleTable/VerticalAlign";
import { useUpdateTableCellOnResize } from "../../Utils/useUpdateTableCellOnResize";

import { baseLineHackChildren, baseLineHackText, bodyCell, emptyBodyCell } from "./StickyTableBodyColumn.styles";

export interface StickyTableBodyColumnProps {
    children: React.ReactNode;
    colSpan?: number;
    rowSpan?: number;
    indent?: "1" | "2" | "3" | "4" | "5" | "6";
    requiredEmpty?: boolean;
    isGray?: boolean;
    horizontalAlign?: HorizontalAlign;
    align?: VerticalAlign;
    useBaselineAlignHack?: boolean;
    paddingTop?: string | number;
    textTopPadding?: boolean;
    visible: boolean;
}

export const StickyTableBodyColumn = (props: StickyTableBodyColumnProps) => {
    if (!props.visible) {
        return <td colSpan={props.colSpan} rowSpan={props.rowSpan} css={themed(emptyBodyCell)} />;
    }
    return <StickyTableBodyColumnView {...props} />;
};

const StickyTableBodyColumnView = (props: StickyTableBodyColumnProps) => {
    const baselineHack = props.align === "baseline" && props.useBaselineAlignHack;
    const indent = props.indent ? Number(props.indent) : undefined;
    const { cellRef, contentRef } = useUpdateTableCellOnResize();
    return (
        <td
            ref={cellRef}
            colSpan={props.colSpan}
            rowSpan={props.rowSpan}
            css={themed(
                bodyCell(
                    props.horizontalAlign,
                    props.align,
                    props.requiredEmpty ?? false,
                    props.isGray ?? false,
                    indent,
                    props.textTopPadding ?? false,
                    props.paddingTop
                )
            )}>
            <div ref={contentRef}>
                {baselineHack ? (
                    <>
                        <span css={baseLineHackText} />
                        <span css={baseLineHackChildren}>{props.children}</span>
                    </>
                ) : (
                    props.children
                )}
            </div>
        </td>
    );
};
